import { useEffect, useState, useMemo } from "react";
import styled from "styled-components";

import {
  Box,
  Button,
  Grid,
  Select,
  Typography,
  MenuItem,
  TextField,
  InputLabel,
  FormControl,
  FormHelperText,
} from "@mui/material";

import { Controller } from "react-hook-form";

const SelectableItem = styled(Box)`
  background-color: ${(props) => (props.isSelected ? "#E5005105" : "none")};
  border: 1px solid ${(props) => (props.isSelected ? "#E50051" : "#282828")};
  padding: 10px;
`;

export default function BankForm({
  control,
  bankList,
  data,
  setSelectedAccount,
  selectedAccount,
  reset,
  emailError,
  setEmailError,
  errors,
}) {
  const [addAccount, setAddAccount] = useState(true);
  const [currentDocType, setCurrentDocType] = useState(10); // 10 -> C.C

  useEffect(() => {
    // ! Corregir
    setSelectedAccount(false);
    reset();
  }, [addAccount]);

  const regexDocNumber = useMemo(() => {
    const onlyNumber = [10, 9, 20, 50];

    if (onlyNumber.includes(currentDocType)) {
      return /^[1-9][0-9]{0,10}$/;
    }

    return /^[a-zA-Z0-9_]{0,10}$/;
  }, [currentDocType]);

  return (
    <>
      <Grid container spacing={2}>
        {/* {data.acount_banks && data.acount_banks && (
          <>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Button
                    variant={addAccount ? "contained" : "outlined"}
                    color="secondary"
                    fullWidth
                    onClick={() => setAddAccount(true)}
                  >
                    {"Agregar cuenta"}
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant={addAccount ? "outlined" : "contained"}
                    color="secondary"
                    fullWidth
                    onClick={() => setAddAccount(false)}
                  >
                    {"Mis cuentas"}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            {!addAccount && (
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  {data?.acount_banks.map((item) => (
                    <Grid item xs={12}>
                      <SelectableItem
                        isSelected={selectedAccount?.bank_id == item.bank_id}
                        onClick={() => setSelectedAccount(item)}
                      >
                        <Typography>
                          <b>{item.bank_name}</b>
                        </Typography>
                        <Box display={"flex"} justifyContent={"space-between"}>
                          <Typography>
                            Ultimos 4 digitos: {item.last_four_number}
                          </Typography>
                          {selectedAccount?.bank_id == item.bank_id && (
                            <Typography color="primary">
                              {"Seleccionada"}
                            </Typography>
                          )}
                        </Box>
                      </SelectableItem>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            )}
          </>
        )} */}

        {addAccount && (
          <>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"banks_id"}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <InputLabel style={{ fontSize: "13px" }}>
                          {"Banco"?.toUpperCase()}
                        </InputLabel>
                        <Select
                          {...field}
                          fullWidth
                          variant="standard"
                          placeholder={"Banco"?.toUpperCase()}
                          error={errors?.banks_id}
                          style={{ fontFamily: "Gotham Medium" }}
                          onChange={(e) => field.onChange(e.target.value)}
                        >
                          {bankList?.map((bank) => (
                            <MenuItem
                              style={{ fontFamily: "Gotham Medium" }}
                              key={bank?.id}
                              value={bank.id}
                            >
                              {bank.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    )}
                  />
                  {errors?.banks_id && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"account_type"}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <InputLabel style={{ fontSize: "13px" }}>
                          {"Tipo de cuenta".toUpperCase()}
                        </InputLabel>
                        <Select
                          {...field}
                          fullWidth
                          variant="standard"
                          placeholder={"Tipo de cuenta".toUpperCase()}
                          style={{ fontFamily: "Gotham Medium" }}
                          error={errors?.account_type}
                          onChange={(e) => field.onChange(e.target.value)}
                        >
                          <MenuItem
                            style={{ fontFamily: "Gotham Medium" }}
                            value={"1"}
                          >
                            {"AHORROS"}
                          </MenuItem>
                          <MenuItem
                            style={{ fontFamily: "Gotham Medium" }}
                            value={"2"}
                          >
                            {"CORRIENTE"}
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                  {errors?.account_type && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={6}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"account"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        type="number"
                        fullWidth
                        inputProps={{ style: { fontFamily: "Gotham Medium" } }}
                        InputLabelProps={{ style: { fontSize: "13px" } }}
                        variant="standard"
                        error={errors?.account}
                        label={"NUMERO DE CUENTA"}
                        placeholder={"NUMERO DE CUENTA"}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                  {errors?.banks_id && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12} md={4}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"type_document"}
                    render={({ field }) => (
                      <FormControl fullWidth>
                        <InputLabel style={{ fontSize: "13px" }}>
                          {"TIPO DE DOCUMENTO"}
                        </InputLabel>
                        <Select
                          {...field}
                          variant="standard"
                          fullWidth
                          placeholder="TIPO DE DOCUMENTO"
                          error={errors?.type_document}
                          style={{ fontFamily: "Gotham Medium" }}
                          onChange={(e) => {
                            setCurrentDocType(parseInt(e.target.value));
                            field.onChange(e.target.value);
                          }}
                        >
                          <MenuItem
                            style={{ fontFamily: "Gotham Medium" }}
                            value="10"
                          >
                            CC
                          </MenuItem>
                          <MenuItem
                            style={{ fontFamily: "Gotham Medium" }}
                            value="20"
                          >
                            CE
                          </MenuItem>
                          <MenuItem
                            style={{ fontFamily: "Gotham Medium" }}
                            value="9"
                          >
                            NIT
                          </MenuItem>
                          <MenuItem
                            style={{ fontFamily: "Gotham Medium" }}
                            value="30"
                          >
                            PA
                          </MenuItem>
                        </Select>
                      </FormControl>
                    )}
                  />
                  {errors?.type_document && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={8}>
                  <Controller
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: "Este campo es requerido*",
                      },
                      minLength: {
                        value: 6,
                        message: "Minimo 6 digitos y/o carácter",
                      },
                      pattern: {
                        value: regexDocNumber,
                        message: "El formato no es válido",
                      },
                    }}
                    name={"number_document"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        type="text"
                        label={"NÚMERO DE DOCUMENTO"}
                        inputProps={{ style: { fontFamily: "Gotham Medium" } }}
                        InputLabelProps={{ style: { fontSize: "13px" } }}
                        variant="standard"
                        placeholder={"NÚMERO DE DOCUMENTO"}
                        error={errors?.number}
                        onChange={(e) => field.onChange(e.target.value)}
                      />
                    )}
                  />
                  {errors?.number_document && (
                    <FormHelperText error>
                      {errors.number_document?.message}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12} md={6}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"first_last_name"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        variant={"standard"}
                        label={"PRIMER APELLIDO"}
                        placeholder={"PRIMER APELLIDO"}
                        inputProps={{ style: { fontFamily: "Gotham Medium" } }}
                        InputLabelProps={{ style: { fontSize: "13px" } }}
                        fullWidth
                        error={errors?.name}
                        onChange={(e) => {
                          field.onChange(e.target.value?.toUpperCase());
                        }}
                      />
                    )}
                  />
                  {errors?.first_last_name && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"second_last_name"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        variant={"standard"}
                        label={"SEGUNDO APELLIDO"}
                        placeholder={"SEGUNDO APELLIDO"}
                        inputProps={{ style: { fontFamily: "Gotham Medium" } }}
                        InputLabelProps={{ style: { fontSize: "13px" } }}
                        fullWidth
                        error={errors?.second_last_name}
                        onChange={(e) => {
                          field.onChange(e.target.value?.toUpperCase());
                        }}
                      />
                    )}
                  />
                  {errors?.name && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>
                <Grid item xs={12}>
                  <Controller
                    rules={{ required: true }}
                    control={control}
                    name={"name"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        variant={"standard"}
                        label={"NOMBRE"}
                        placeholder={"Nombre"}
                        inputProps={{ style: { fontFamily: "Gotham Medium" } }}
                        InputLabelProps={{ style: { fontSize: "13px" } }}
                        fullWidth
                        error={errors?.name}
                        onChange={(e) => {
                          field.onChange(e.target.value?.toUpperCase());
                        }}
                      />
                    )}
                  />
                  {errors?.name && (
                    <FormHelperText error>
                      {"Este campo es requerido*"}
                    </FormHelperText>
                  )}
                </Grid>

                <Grid item xs={12}>
                  <Controller
                    rules={{
                      required: true,
                    }}
                    control={control}
                    name={"email"}
                    render={({ field }) => (
                      <TextField
                        {...field}
                        variant={"standard"}
                        label={"CORREO ELECTRÓNICO"}
                        placeholder={"CORREO ELECTRÓNICO"}
                        inputProps={{ style: { fontFamily: "Gotham Medium" } }}
                        InputLabelProps={{ style: { fontSize: "13px" } }}
                        fullWidth
                        error={errors?.email}
                        onChange={(e) => {
                          field.onChange(e.target.value?.toUpperCase());
                          setEmailError("");
                        }}
                      />
                    )}
                  />
                  {emailError ||
                    (errors?.email && (
                      <FormHelperText error>
                        {emailError ? emailError : "Este campo es requerido*"}
                      </FormHelperText>
                    ))}
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </>
  );
}
